var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.second !== 0)?_c('div',{staticClass:"countDown"},[_c('p',{staticClass:"countdown-box"},[(_vm.day - 0)?_c('span',[_vm._v(_vm._s(_vm.day)+" : ")]):_vm._e(),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.hour)+" : ")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.minute)+" : ")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.second))])])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }